@use "../../../common/scss/colors";
@use "../../../common/scss/mixins";
@use "../../../common/scss/font";

.GARMatrix {
  text-align: center;
  width: 100%;
  padding: 1rem;

  @include mixins.under_md_ms {
    padding: 0.5rem;
  }

  &__title {
    font-size: font.$size--big_s;
    line-height: font.$size--huge;
    color: colors.$amway_black;
    font-weight: font.$weight--bold;
    margin-bottom: 0.25rem;
  }

  &__py {
    font-size: font.$size--big;
    line-height: font.$size--big_s;
    color: colors.$blue;
    font-weight: font.$weight--bold;
    margin-bottom: 1.5rem;
  }

  &__mobile {
    display: none;

    @include mixins.under_md_ms {
      display: block;
    }
  }

  &__desktop {
    display: block;

    @include mixins.under_md_ms {
      display: none;
    }
  }

  table {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }

  table,
  td,
  th {
    border-collapse: collapse;
    text-align: center;
    font-size: font.$size--standard;

    @include mixins.under_md_ms {
      font-size: font.$size--small;
    }
  }

  th {
    color: white;
    font-weight: font.$weight--bold;
    background-color: colors.$amway_black;
    border: 1px solid colors.$amway_black;
    padding: 1rem;
  }

  td {
    border: 1px solid colors.$light_gray;
    padding: 1rem;
  }

  &__disclamer-row {
    border-collapse: separate;
    border-spacing: 0 1em;
    background-color: colors.$amway_white;

    td {
      border-left: 1px solid colors.$amway_white;
      border-right: 1px solid colors.$amway_white;
      border-bottom: 1px solid colors.$amway_white;
    }
  }

  &__spacer-row {
    td {
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
      padding: 11px;
    }
  }

  .current {
    background-color: colors.$light_green_8;
    color: colors.$light_green;
    font-weight: font.$weight--bold;
  }
}
